module.exports = __webpack_public_path__ + "static/media/BD-key-insights-white-paper-How-to-effectively-optimize-medication-inventory.2678b6c5.pdf";